import { normalizeAllocation } from './normalizers';
import { backEndAPIUrl } from 'constants/values';

export const adjustForMini = response => {
  if (response.series === undefined) {
    const wrappedResponse = {};
    const placeHolderBodyStyles = [{ id: '1', description: '' }];
    wrappedResponse.series = response.bodyStyles;
    wrappedResponse.bodyStyles = placeHolderBodyStyles;
    const wrappedModels = [...response.models];
    wrappedModels.forEach(model => {
      model.seriesId = model.bodyStyleId;
      model.bodyStyleId = '1';
    });
    wrappedResponse.series.forEach(serie => (serie.bodyStyles = ['1']));
    wrappedResponse.models = wrappedModels;
    return wrappedResponse;
  } else {
    return response;
  }
};

export const getSeriesAllocation = async values => {

  const url = `${backEndAPIUrl}/dashboard/seriesAllocation`;
  // Safely get from sessionStorage or use empty fallback

  const accessToken = sessionStorage.getItem('access_token') || '';
  const idToken = sessionStorage.getItem('id_token') || '';
  let userId = '';

  try {
    const userInfo = JSON.parse(sessionStorage.getItem('user_info') || '{}');
    userId = userInfo?.bmwdcsnetuid || '';
  } catch (e) {
    sessionStorage.setItem('Failed to parse user_info from sessionStorage:', e);
  }

  const response = await fetch(url, {
    method: 'GET',
    credentials: 'include',
    cache: 'no-cache',
    headers: {

      Authorization: `Bearer ${accessToken}`,
      'x-id-token': idToken,
      'x-user-id': userId,
    },

  });

  if (response.ok) {
    const responseBody = await response.json();
    const adjustedResponseBody = adjustForMini(responseBody);
    return normalizeAllocation(adjustedResponseBody);
  } else if (response.status === 422) {
    await response.json(); 
  }
};
